import PaymentLogo from 'components/FrictionlessCheckout/Payment/PaymentLogo/PaymentLogo';
import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import CheckoutActions from 'actions/CheckoutActions';

const { wrapHOC } = FrameworkUtils;

const fields = null;

const functions = {
    paymentNumberUpdated: CheckoutActions.paymentNumberUpdated
};

const withPaymentLogoProps = wrapHOC(connect(fields, functions));

export default withPaymentLogoProps(PaymentLogo);
